module.exports = __webpack_public_path__ + "fonts/KeepIconRegular.2ebac0f1.woff2";